<template>
	<v-col cols="10" class="flex-none mx-auto">
		<div class="inventory-items">
			<p class="inventory-items-title">Package Items</p>
			<div class="flex-table" role="table-head">
				<div class="flex-table-row header" role="row-group">
					<div class="flex-table-cell-header" role="column-header">&nbsp;</div>
					<div class="flex-table-cell-header" role="column-header">Style Code</div>
					<div class="flex-table-cell-header" role="column-header">Description</div>
					<div class="flex-table-cell-header" role="column-header">Quantity</div>
					<div class="flex-table-cell-header" role="column-header">Default</div>
					<div class="flex-table-cell-header" role="column-header">Price Included</div>
					<div class="flex-table-cell-header" role="column-header">Total</div>
				</div>
			</div>
			<div class="flex-table" role="table-body">
				<div class="flex-table-row header" role="row-group">
					<div class="flex-table-cell" role="cell">&nbsp;</div>
					<div class="flex-table-cell d-flex align-center" role="cell">
						<SystemCategoryIcon :systemCategoryId="item.systemCategoryId" />
						{{ item.styleCode }}
					</div>
					<div class="flex-table-cell" role="cell">{{ item.description }}</div>
					<div class="flex-table-cell" role="cell">&nbsp;</div>
					<div class="flex-table-cell" role="cell">&nbsp;</div>
					<div class="flex-table-cell" role="cell">&nbsp;</div>
					<div class="flex-table-cell" role="cell">{{ renderPrice(item.price) }}</div>
				</div>
				<div
					v-for="(pkgItem, i) in itemData.packageItems"
					:key="i"
					class="flex-table-row"
					role="row-group"
				>
					<div class="flex-table-cell" role="cell">{{ renderLineNumber(pkgItem) }}</div>
					<div class="flex-table-cell" role="cell">
						<v-icon class="inventory-items-level">mdi-subdirectory-arrow-right</v-icon>
						<SystemCategoryIcon :system-category-id="pkgItem.packageCategory.systemCategoryId" />
						<div class="form-input">
							<v-combobox
								prepend-inner-icon="mdi-magnify"
								dense
								outlined
								placeholder="Search Style Codes"
								hide-details="auto"
								:value="getComboboxValue(pkgItem) || defaultPackageItem"
								@input="updatePkgItem($event, i)"
								:items="searchResults"
								item-text="packageCategory.name"
								@keyup="searchPackageCategories($event.srcElement.value)"
								:disabled="!canManageInventory"
							>
								<template v-slot:item="{ item, attrs, on }">
									<v-list-item v-on="on" v-bind="attrs">
										<v-list-item-content>
											<v-list-item-title>
												<v-row no-gutters align="center">
													<SystemCategoryIcon :system-category-id="item.systemCategoryId" />
													{{ `${item.packageCategory.name} - ${item.packageCategory.description}` }}
												</v-row>
											</v-list-item-title>
										</v-list-item-content>
									</v-list-item>
								</template>
							</v-combobox>
							<v-btn
								v-if="pkgItem.type !== 'SubItem' && pkgItem.packageCategory.systemCategoryId !== 0"
								plain
								color="accent"
								class="sales-table-line-subaction"
								@click="pkgItem.subItems.push({ ...defaultPackageItem, randKey: Math.random() })"
							>
								Add a sub-item
							</v-btn>
						</div>
					</div>
					<div class="flex-table-cell" role="cell">
						<div class="form-input">
							<v-text-field
								outlined
								dense
								hide-details="auto"
								v-model="pkgItem.packageCategory.description"
								disabled
							></v-text-field>
						</div>
					</div>
					<div class="flex-table-cell" role="cell">
						<div class="form-input">
							<v-text-field
								class="number-input"
								outlined
								dense
								hide-details="auto"
								v-model="pkgItem.quantity"
								type="number"
								min="0"
								:disabled="!canManageInventory"
							></v-text-field>
						</div>
					</div>
					<div class="flex-table-cell" role="cell">
						<div class="form-input">
							<v-select
								v-model="pkgItem.isDefault"
								:items="[
									{ text: 'Yes', value: true },
									{ text: 'No', value: false },
								]"
								item-text="text"
								item-value="value"
								dense
								outlined
								hide-details="auto"
								:disabled="!canManageInventory"
							></v-select>
						</div>
					</div>
					<div class="flex-table-cell" role="cell">
						<div class="form-input">
							<v-select
								v-model="pkgItem.priceIncluded"
								:items="[
									{ text: 'Yes', value: true },
									{ text: 'No', value: false },
								]"
								item-text="text"
								item-value="value"
								dense
								outlined
								hide-details="auto"
								:disabled="!canManageInventory"
							></v-select>
						</div>
					</div>
					<div class="flex-table-cell" role="cell">
						<v-btn :disabled="!canManageInventory" icon @click="removePackageItem(pkgItem)"
							><v-icon>mdi-close</v-icon></v-btn
						>
					</div>
					<div
						v-for="(subItem, subIdx) in pkgItem.subItems"
						:key="subIdx"
						class="flex-table-row"
						role="row-group"
					>
						<div class="flex-table-cell" role="cell">{{ renderLineNumber(subItem) }}</div>
						<div class="flex-table-cell" role="cell">
							<v-icon class="subitem-table-level">&nbsp;</v-icon>
							<v-icon class="inventory-items-level">mdi-subdirectory-arrow-right</v-icon>
							<SystemCategoryIcon :system-category-id="subItem.info.systemCategoryId" />
							<div class="form-input">
								<v-combobox
									prepend-inner-icon="mdi-magnify"
									dense
									outlined
									placeholder="Search Style Codes"
									hide-details="auto"
									:value="getComboboxValue(subItem) || defaultPackageItem"
									@input="updatePkgSubItem($event, i, subIdx)"
									:items="searchResults"
									item-text="info.name"
									@keyup="searchSubItems($event.srcElement.value)"
									:disabled="!canManageInventory"
								>
									<template v-slot:item="{ item, attrs, on }">
										<v-list-item v-on="on" v-bind="attrs">
											<v-list-item-content>
												<v-list-item-title>
													<v-row no-gutters align="center">
														<SystemCategoryIcon :system-category-id="item.systemCategoryId" />
														{{
															`${item.packageCategory.name} - ${item.packageCategory.description}`
														}}
													</v-row>
												</v-list-item-title>
											</v-list-item-content>
										</v-list-item>
									</template>
								</v-combobox>
								<span
									v-if="'braidPosition' in subItem && subItem.braidPosition"
									class="font-italic grey--text"
								>
									{{ subItem.braidPosition }}
								</span>
							</div>
						</div>
						<div class="flex-table-cell" role="cell">
							<div class="form-input">
								<v-text-field
									outlined
									dense
									hide-details="auto"
									v-model="subItem.info.description"
									disabled
								></v-text-field>
							</div>
						</div>
						<div class="flex-table-cell" role="cell">
							<div class="form-input">
								<v-text-field
									class="number-input"
									outlined
									dense
									hide-details="auto"
									v-model="subItem.quantity"
									type="number"
									min="0"
									:disabled="!canManageInventory"
								></v-text-field>
							</div>
						</div>
						<div class="flex-table-cell" role="cell">
							<div class="form-input">
								<v-select
									v-model="subItem.isDefault"
									:items="[
										{ text: 'Yes', value: true },
										{ text: 'No', value: false },
									]"
									item-text="text"
									item-value="value"
									dense
									outlined
									hide-details="auto"
									:disabled="!canManageInventory"
								></v-select>
							</div>
						</div>
						<div class="flex-table-cell" role="cell">
							<div class="form-input">
								<v-select
									v-model="subItem.priceIncluded"
									:items="[
										{ text: 'Yes', value: true },
										{ text: 'No', value: false },
									]"
									item-text="text"
									item-value="value"
									dense
									outlined
									hide-details="auto"
									:disabled="!canManageInventory"
								></v-select>
							</div>
						</div>
						<div class="flex-table-cell" role="cell">
							<v-btn :disabled="!canManageInventory" icon @click="removePackageItem(subItem, true)"
								><v-icon>mdi-close</v-icon></v-btn
							>
						</div>
					</div>
				</div>
				<div class="inventory-items-action">
					<v-btn v-if="canManageInventory" plain color="accent" @click="addPackageItem()">
						<v-icon>mdi-plus</v-icon>
						Add Another Item
					</v-btn>
				</div>
			</div>
		</div>
	</v-col>
</template>

<script>
import gql from "graphql-tag";
import SystemCategoryIcon from "@/components/SystemCategoryIcon.vue";
import { renderPrice } from "@/helpers/PricingCalculator";
export default {
	name: "InventoryItemPackageView",
	props: {
		item: {
			type: Object,
		},
		canManageInventory: {
			type: Boolean,
			default: false,
		},
	},
	components: {
		SystemCategoryIcon,
	},
	data() {
		return {
			itemData: {
				packageItems: [],
			},
			showSearchByIndex: null,
			searchResults: [],
			selectedComboboxValues: [],
			defaultPackageItem: {
				name: "",
				packageCategoryId: null,
				info: { systemCategoryId: null, name: "", description: "" },
				itemData: { systemCategoryId: null, styleCode: "", description: "" },
				packageCategory: { systemCategoryId: null, name: "", description: "" },
				subItems: [],
				quantity: 1,
				isDefault: true,
				priceIncluded: true,
				sequence: 10000, //set sorting start point really high so that when the user sorts the last new item will always be the last spot
			},
		};
	},
	methods: {
		renderPrice,

		addPackageItem() {
			let newItem = { ...this.defaultPackageItem, randKey: Math.random() };
			this.itemData.packageItems.push(newItem);
		},

		removePackageItem(itemToRemove, isSubItem = false) {
			if (isSubItem) {
				// Find parent package item
				const parentItem = this.itemData.packageItems.find(
					(pkgItem) => pkgItem.subItems && pkgItem.subItems.includes(itemToRemove)
				);
				// Remove sub-item from the parent item's subItems array
				if (parentItem) {
					parentItem.subItems = parentItem.subItems.filter((subItem) => subItem !== itemToRemove);
				}
			} else {
				// It's a top-level package item, remove it directly
				this.itemData.packageItems = this.itemData.packageItems.filter(
					(pkgItem) => pkgItem !== itemToRemove
				);
			}
		},

		getComboboxValue(item) {
			let index = this.computedItemsTable.findIndex((obj) => obj == item);
			return this.computedItemsTable[index];
		},

		async searchPackageCategories(searchTerm) {
			try {
				//send gql query to get current package items
				const res = await this.$apollo.query({
					query: gql`
						query SearchPackageCategories($searchTerm: String) {
							packageCategories(
								skip: 0
								take: 30
								order: { name: ASC }
								where: {
									or: [
										{ name: { contains: $searchTerm } }
										{ description: { contains: $searchTerm } }
									]
								}
							) {
								items {
									packageCategoryId
									systemCategoryId
									inventoryItemId
									name
									description
									inventoryItem {
										styleCode
										description
									}
								}
								pageInfo {
									hasNextPage
									hasPreviousPage
								}
							}
						}
					`,
					variables: {
						searchTerm,
					},
					fetchPolicy: "no-cache",
				});

				const inventoryItemResult = await this.$apollo.query({
					query: gql`
						query SearchInventoryListing(
							$searchTerm: String = null
							$itemTypes: [String!]
							$offset: Int! = 0
							$take: Int! = 20
						) {
							inventoryListings(
								searchTerm: $searchTerm
								skip: $offset
								take: $take
								order: { styleCode: ASC }
								where: { inactiveDate: { eq: null }, type: { in: $itemTypes } }
							) {
								items {
									inventoryItemId
									systemCategoryId
									styleCode
									description
									type
								}
								pageInfo {
									hasNextPage
									hasPreviousPage
								}
							}
						}
					`,
					fetchPolicy: "no-cache",
					variables: {
						searchTerm: searchTerm,
						itemTypes: ["Item"],
					},
				});

				let packageCategories = res?.data?.packageCategories?.items || [];
				let inventorySearchResults = inventoryItemResult?.data?.inventoryListings?.items || [];
				let packageCategoryItemIds = packageCategories.map((item) => item.inventoryItemId);

				// Filter out inventory items that are already in packageCategories
				let filteredInventorySearchResults = inventorySearchResults.filter(
					(inventoryItem) => !packageCategoryItemIds.includes(inventoryItem.inventoryItemId)
				);

				// Format the package categories results
				let formattedPackageCategories = packageCategories.map((obj) => ({
					...obj,
					packageCategory: {
						systemCategoryId: obj.systemCategoryId,
						name: obj.name,
						description:
							obj.description && obj.description.trim().length > 0
								? obj.description
								: obj.inventoryItem.description,
					},
					info: {
						systemCategoryId: obj.systemCategoryId,
						name: obj.styleCode ?? obj.name,
						description: obj.description,
					},
					subItems: [],
					quantity: 1,
					isDefault: true,
					priceIncluded: true,
					sequence: 10000,
				}));

				// Format the inventory search results
				let formattedInventorySearchResults = filteredInventorySearchResults.map((item) => ({
					inventoryItemId: item.inventoryItemId,
					systemCategoryId: item.systemCategoryId,
					packageCategory: {
						systemCategoryId: item.systemCategoryId,
						name: item.styleCode,
						description: item.description,
					},
					info: {
						systemCategoryId: item.systemCategoryId,
						name: item.styleCode ?? item.name,
						description: item.description,
					},
					subItems: [],
					quantity: 1,
					isDefault: true,
					priceIncluded: true,
					sequence: 10000,
				}));

				// Merge the results from both queries
				this.searchResults = [...formattedPackageCategories, ...formattedInventorySearchResults];
				console.log(`Search results for ${searchTerm}`, this.searchResults);
			} catch (error) {
				console.log(error);
			}
		},

		async searchSubItems(searchTerm) {
			try {
				//send gql query to get current sub items and filter by the searched terms in itemData.styleCode
				const res = await this.$apollo.query({
					query: gql`
						query GetSubItems($searchTerm: String!) {
							inventoryListings(
								order: { systemCategoryId: ASC }
								where: { type: { eq: "subItem" }, styleCode: { contains: $searchTerm } }
							) {
								items {
									inventoryItemId
									systemCategoryId
									styleCode
									description
								}
								pageInfo {
									hasNextPage
									hasPreviousPage
								}
							}
							subItemCategories(
								order: { systemCategoryId: ASC }
								where: { name: { contains: $searchTerm } }
							) {
								items {
									subItemCategoryId
									systemCategoryId
									styleCode: name
									description
								}
								pageInfo {
									hasNextPage
									hasPreviousPage
								}
							}
						}
					`,
					variables: {
						searchTerm: searchTerm,
					},
					fetchPolicy: "no-cache",
				});
				//replace with res.data once api is setup
				console.log(`searching for sub items with ${searchTerm}`, [
					...res.data.inventoryListings.items,
					...res.data.subItemCategories.items,
				]);
				//change the returned gql data structure to work with rendering format
				this.searchResults = [
					...res.data.subItemCategories.items,
					...res.data.inventoryListings.items,
				].map((obj) => {
					return {
						...obj,
						itemData: {
							systemCategoryId: obj.systemCategoryId,
							styleCode: obj.styleCode,
							description: obj.description,
						},
						packageCategory: {
							systemCategoryId: obj.systemCategoryId,
							name: obj.styleCode,
							description: obj.description,
						},
						info: {
							systemCategoryId: obj.systemCategoryId,
							name: obj.styleCode,
							description: obj.description,
						},
						name: obj.styleCode,
						packageCategoryId: null,
						quantity: 1,
						isDefault: true,
						priceIncluded: true,
						sequence: 10000,
					};
				});
			} catch (error) {
				console.log(error);
			}
		},

		async getPackageCategorySubItems(itemId) {
			try {
				const res = await this.$apollo.query({
					query: gql`query {
				        inventoryItemById(id: ${itemId}) {
				            inventoryItemId
							type
                            vendorId
                            styleCode
                            description
                            vendorCost
                            leadTime
                            price
                            systemCategoryId
                            vendorPartNumber
                            inactiveDate
                            infiniteInventory
                            dropShip
                            packingList
							processTypeId
                            stockItems
                            createDate
                            phantomSubItems {
								subItemCategoryId: phantomSubItemId
								quantity
								isDefault
								priceIncluded
								braidPosition
                                itemData: subItemCategory {
                                    systemCategoryId
                                    styleCode: name
                                    description
                                }
							}
				        }
				    }`,
					fetchPolicy: "no-cache",
				});

				console.log("getting inventory item subitems", res);
				// Transform the phantomSubItems to include itemData properties directly
				const flattenedSubItems = res.data.inventoryItemById.phantomSubItems.map((subItem) => ({
					...subItem,
					packageCategory: {
						systemCategoryId: subItem.itemData.systemCategoryId,
						name: subItem.itemData.styleCode,
						description: subItem.itemData.description,
					},
					info: {
						systemCategoryId: subItem.itemData.systemCategoryId,
						name: subItem.itemData.styleCode,
						description: subItem.itemData.description,
					},
				}));

				return flattenedSubItems;
			} catch (error) {
				console.log(error);
			}
		},

		renderLineNumber(itemObj) {
			let lineNumber = this.computedItemsTable.findIndex((obj) => obj == itemObj);

			return lineNumber >= 0 ? lineNumber + 1 : "#";
		},

		async updatePkgItem(selected, i) {
			let pkgItem = selected.inventoryItemId
				? { ...selected, subItems: await this.getPackageCategorySubItems(selected.inventoryItemId) }
				: selected;

			this.$set(this.itemData.packageItems, i, pkgItem);
			this.searchResults = [];
		},

		updatePkgSubItem(selected, pIdx, sIdx) {
			this.$set(this.itemData.packageItems[pIdx].subItems, sIdx, selected);
			this.searchResults = [];
		},
	},
	computed: {
		storeItem() {
			return this.$store.getters.inventoryItem;
		},
		computedItemsTable() {
			let itemsArr = [];

			if (this.itemData.packageItems && this.itemData.packageItems.length > 0) {
				//loop through all level 1 items and add them to the itemsArr and check for child items
				this.itemData.packageItems.forEach((item) => {
					itemsArr.push(item);

					if (item.subItems && item.subItems.length > 0) {
						//loop through all level 2 items and add them to the itemsArr and check for sub child items
						item.subItems.forEach((childItem, index, _array) => {
							itemsArr.push(childItem);

							if (childItem.subItems && childItem.subItems.length > 0) {
								//loop through all level 3 items and add them to the itemsArr
								childItem.subItems.forEach((sub, index, _array) => {
									itemsArr.push(sub);
								});
							}
						});
					}
				});
			}

			return itemsArr;
		},
	},
	watch: {
		// Re-adopt the store object whenever the parent view's async fetch
		// replaces it — children mount before the parent's mounted() completes,
		// so a one-shot read here can capture a stale tree and orphan edits.
		storeItem: {
			immediate: true,
			handler(item) {
				this.itemData = item;
			},
		},
	},
	beforeDestroy() {
		//push current item data to state
		this.$store.dispatch("updateInventoryItem", this.itemData);

		//let parent component know data has been updated in state
		this.$emit("updated");
	},
};
</script>

<style lang="scss" scoped>
.inventory {
	&-form {
		width: 50rem;
		margin: 0 auto;

		.form-radio {
			justify-content: center;
		}
	}

	&-items {
		position: relative;

		&-title {
			font-size: 1.4rem;
		}

		.subitem-table-level {
			display: inline-flex;
			justify-content: center;
			align-items: center;
			border: 1px solid transparent;
			border-radius: 5px;
			min-height: 5rem;
			min-width: 2rem;
			margin-right: 1rem;
		}

		.flex-table[role="table-body"] {
			background-color: $color-white;
		}

		.flex-table-row.header {
			align-items: center;
		}

		.flex-table-row .flex-table-cell {
			align-items: flex-start;
			padding: 1rem;
		}

		.flex-table-cell,
		.flex-table-cell-header {
			&:nth-child(1) {
				width: 3%;
				justify-content: center;
			}
			&:nth-child(2) {
				width: 27%;
			}
			&:nth-child(3) {
				width: 32%;
			}
			&:nth-child(4) {
				width: 10%;
			}
			&:nth-child(5) {
				width: 10%;
			}
			&:nth-child(6) {
				width: 10%;
			}
			&:nth-child(7) {
				width: 8%;
				justify-content: center;
			}
		}

		.form-input {
			margin: 0;
			width: 100%;
		}

		&-level {
			display: inline-flex;
			justify-content: center;
			align-items: center;
			border: 1px solid transparent;
			border-radius: 5px;
			min-height: 5rem;
			min-width: 5rem;
			margin-right: 1rem;
		}

		&-action {
			display: block;
			padding: 0.8rem;
			border-top: 1px solid $color-gray;
		}
	}
}
</style>
